import { render, staticRenderFns } from "./ModalMoreDetail.vue?vue&type=template&id=4e9d5460&scoped=true&"
import script from "./ModalMoreDetail.vue?vue&type=script&lang=js&"
export * from "./ModalMoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalMoreDetail.vue?vue&type=style&index=0&id=4e9d5460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d5460",
  null
  
)

export default component.exports